module.exports = __webpack_public_path__ + "static/media/ka.d24478aa.ogg";